import { Button, Dialog, DialogTitle, IconButton } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import { Form, Formik } from 'formik';
import React, { Fragment, useState, useEffect } from 'react';
import Loader from "react-loader-spinner";
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { selectUser } from '../../../../features/userSlice';
import db, { fb_storage } from '../../services/Firebase';
import TestimonialValidatorDef from '../models/TestimonialFormValidator';
import { customStyles } from '../Styles/UIStyles';
import MultilineTextField from '../UIElements/MultilineTextField';
import TextField from '../UIElements/TextField';



export const UpdateTestimonial = () => {
  const history = useHistory();
  const styles = customStyles();
  const params = useParams();
  const userEmail = useSelector(selectUser)
  const [testimonial_info, setTestimonialInfo] = useState({});
  const [imageAsFile, setImageAsFile] = useState('')
  const [imageAsUrl, setImageAsUrl] = useState('')
  const [showDialog, setShowDialog] = useState(false)
  const [loading, setLoading] = useState(true)

  function handleChange(e) {
    const image = e.target.files[0]
    setImageAsUrl(URL.createObjectURL(image))
    setImageAsFile(imageAsFile => (image))
  };


  const fetchTestimonialInfo = async () => {
    const testimonialRef = await db.collection('TestimonialsInformation').doc(params.id).get();
    setTestimonialInfo({ data: testimonialRef.data(), id: testimonialRef.id })
    setLoading(false);
  };


  useEffect(() => {
    fetchTestimonialInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  return (

    <div>
      {
        loading && (
          <div className={styles.dialog} >
            <Loader
              type="TailSpin"
              color="#00BFFF"
              height={100}
              width={100}
            />
          </div>
        )
      }
      {
        !loading &&
        <Formik
          initialValues={{
            client_name: testimonial_info.data.client_name,
            testimonial_details: testimonial_info.data.testimonial_details
          }}
          validationSchema={TestimonialValidatorDef}
          onSubmit={values => {
            setShowDialog(!showDialog);
            if (imageAsFile) {
              var timeStamp = Date.now()
              const ref = fb_storage.ref().child(`/testimonial_images/${userEmail}/${timeStamp}_${imageAsFile.name}`)
              ref.put(imageAsFile)
                .then(() => ref.getDownloadURL())
                .then(fireBaseUrl => {
                  db.collection('TestimonialsInformation')
                    .doc(testimonial_info.id)
                    .set({
                      user_id: userEmail,
                      client_name: values.client_name,
                      testimonial_details: values.testimonial_details,
                      image: fireBaseUrl,
                      active: testimonial_info.data.active
                    })
                    .then(() => {
                      setShowDialog(!showDialog);
                      history.push("/manage-testimonials");
                    })
                    .catch((error) => {
                      setShowDialog(!showDialog);
                      alert(error.message);
                    });
                })
            } else {
              db.collection('TestimonialsInformation')
                .doc(testimonial_info.id)
                .set({
                  user_id: userEmail,
                  client_name: values.client_name,
                  testimonial_details: values.testimonial_details,
                  image: testimonial_info.data.image,
                  active: testimonial_info.data.active
                })
                .then(() => {
                  setShowDialog(!showDialog);
                  history.push("/manage-testimonials");
                })
                .catch((error) => {
                  setShowDialog(!showDialog);
                  alert(error.message);
                });
            }
          }}
        >
          <Form>
            <div>
              <h2 className={styles.section_header}>
                <p>
                  <label htmlFor="icon-button-file">
                    <IconButton className={styles.icon_header} aria-label="back-button" onClick={() => history.push("/manage-testimonials")} >
                      <ArrowBackIosIcon fontSize="small" />
                    </IconButton>
                  </label>
                  Update Testimonial
                </p>
              </h2>
            </div>
            <div id="theformone" >
              <h4 className={styles.section_header}>
                Testimonials and Transformations
              </h4>
              <br />
              <p className={styles.form_header}>
                <label style={{ color: 'red' }}>* </label> Name of the Client
              </p>
              <TextField className={styles.textfield}
                id="client_name"
                name="client_name"
                label="Enter name"
              />
              <br />
              <p className={styles.form_header}>
                <label style={{ color: 'red' }}>* </label> Testimonial
              </p>
              <MultilineTextField className={styles.textfield}
                id="testimonial_details"
                name="testimonial_details"
                label="Enter testimonial"
              />
              <p className={styles.form_header}>
                Transformation Image
              </p>
              <div>
                <Fragment>
                  <div>
                    {
                      imageAsUrl ? imageAsUrl && (
                        <figure>
                          <img src={imageAsUrl} alt='' width='128' height='128' />
                        </figure>
                      ) : testimonial_info.data ? testimonial_info.data.image && (
                        <figure>
                          <img src={testimonial_info.data.image} alt='' width='128' height='128' />
                        </figure>
                      ) : null
                    }
                  </div>
                  <input
                    color="primary"
                    accept="image/*"
                    type="file"
                    onChange={handleChange}
                    id="icon-button-file"
                    style={{ display: 'none', }}
                  />
                  <p className={styles.form_header}>
                    <label htmlFor="icon-button-file">
                      <IconButton style={{ color: 'black' }} aria-label="upload picture" component="span">
                        <PhotoCamera />
                      </IconButton>
                    </label>
                    Upload Image
                  </p>
                </Fragment>
              </div>
            </div>
            <Button className={styles.primary_button} type='submit' variant="outlined" style={{ width: '100px' }}>  Update  </Button>
          </Form>
        </Formik>
      }
      {
        showDialog && (
          <Dialog open={showDialog} className={styles.dialog}>
            <DialogTitle id="testimonial_progress_title"><p>Saving Testimonial details...</p><p>Soon will be redirected to manage testimonials...</p></DialogTitle>
            <div className={styles.dialog} >
              <Loader
                type="TailSpin"
                color="#00BFFF"
                height={100}
                width={100}
              />
            </div>
          </Dialog>
        )
      }
    </div>

  )
}